/** biome-ignore-all lint/correctness/useExhaustiveDependencies: TODO: fix */
import { useCallback, useEffect, useRef } from 'react';
import { Form, Input } from 'antd';

import { isRequiredField } from '../../../utilz';
import formLabelToolTip from '../Common/formLabelToolTip';

const FormTextArea = ({
  placeholder = '',
  label,
  editMode = false,
  forFilter = false,
  margin = 'mb-15',
  singleLineMode = false,
  name = `testFiled-${Math.random()}`,
  rules = [],
  colon = false,
  inverMode = false,
  rows = 0,
  enableAutoFocus = true,
  className = '',
  onChange = false,
  defaultValue = '',
  fillHeight = false,
  tooltip = false,
  onBlur = () => {},
  tabIndex = false,
  disableValidation = false,
  maxLength = false,
  dataTestId = undefined,
  isRequired = false,
}) => {
  const autoGrow = (el) => {
    if (!fillHeight) {
      el.target.style.height = '5px';
      const height = el.target.scrollHeight;
      el.target.style.height = `${height - (editMode ? 0 : 8)}px`;
    }
  };

  let textRef = useRef(null);
  const setHeightBasedOnRef = useCallback(() => {
    textRef.resizableTextArea.textArea.style.height = '5px';
    const height = textRef.resizableTextArea.textArea.scrollHeight;
    textRef.resizableTextArea.textArea.style.height = `${height}px`;
  }, []);

  useEffect(() => {
    if (textRef.current && !rows) {
      if (enableAutoFocus) {
        textRef.current.focus();
      } else {
        setHeightBasedOnRef();
      }
      textRef.current.blur();
    }
  }, [enableAutoFocus, setHeightBasedOnRef, rows]);

  return (
    <Form.Item
      tooltip={tooltip ? formLabelToolTip(tooltip) : null}
      className={`form-textarea-container ${className} ${inverMode ? 'invert-mode' : ''} ${margin} ${
        singleLineMode ? 'single-line-mode' : ''
      } form-input-container ${!editMode ? 'edit-mode-off' : ''} ${fillHeight ? 'full-height' : ''}`}
      name={name}
      rules={disableValidation ? [] : rules}
      {...(label
        ? {
            label: (
              <span>
                {label}
                {((rules.length > 0 && isRequiredField(rules) && !disableValidation) || isRequired) && (
                  <span className="required">*</span>
                )}
              </span>
            ),
          }
        : {})}
      labelCol={10}
      colon={colon}
      data-testid={dataTestId}
      initialValue={defaultValue}
    >
      <Input.TextArea
        id={name}
        rows={rows}
        {...(!rows
          ? {
              onFocus: autoGrow,
              onInput: autoGrow,
              // biome-ignore lint/suspicious/noAssignInExpressions: <need to cover this rule>
              ref: (input) => (textRef = input),
            }
          : {})}
        readOnly={!editMode}
        placeholder={editMode ? placeholder || label : ''}
        className={`${forFilter ? 'filter-input' : 'form-input'} ${rows ? 'custom-scroll-bar' : ''}`}
        {...(onChange ? { onChange } : {})}
        onBlur={onBlur}
        {...(tabIndex ? { tabIndex } : {})}
        {...(maxLength ? { maxLength } : {})}
      />
    </Form.Item>
  );
};

export default FormTextArea;
